module.exports = __webpack_public_path__ + "static/img/27.76c3167.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/27.png
// module id = SIWU
// module chunks = 0